<template>
    <div class="product" style="min-width: 1300px">
        <div class="product" style="padding: 0px 20px 20px 0;">
            <div class="content">

                <div class="product-menu" :class="{'product-menu-closed':isCollapse==true,'product-menu-put':isCollapse==false}">
                    <!--<div class="menus-title">产品目录</div>-->
                    <div class="flod"><i :class="iconClass" @click="fullScreen" style='cursor: pointer;'></i></div>
                    <el-menu
                             class="el-menu-vertical-demo"
                             @open="handleOpen"
                             @close="handleClose"
                             :unique-opened="true"
                             :collapse="isCollapse"
                             :default-openeds="[menuIndex]">
                        <el-menu-item>
                            <div class="menu-headline" slot="title"> Product catalog </div>
                        </el-menu-item>


                        <div class="menu-left" v-for="(item,index) in menuContent" :key="index">
                            <el-menu-item v-if="!item.child" :index="index">
                                <div class="menu-box">
                                    <div class="menu-title" slot="title">{{item.type_e_all_name}}</div>
                                    <!--div class="menu-text" slot="title">{{item.type_e_all_name}}</div-->
                                </div>
                            </el-menu-item>

                            <el-submenu  v-if="item.child" :index="index">
                                <template slot="title">
                                    <div class="menu-box">
                                        <div class="menu-title" slot="title">{{item.type_e_all_name}}</div>
                                        <!--div class="menu-text" slot="title">{{item.type_e_all_name}}</div-->
                                    </div>
                                </template>
                                <el-menu-item-group>
                                    <el-menu-item @click="noIdentifying(index+'-'+dataIndex,index )" :class="{'menu-item identifying':identifying===index+'-'+dataIndex,'menu-item ':identifying===index+'-'+dataIndex}" v-for="(data , dataIndex) in item.child" :key="dataIndex" :index="index+'-'+dataIndex">
<!--                                        {{data.type_name}}-->
                                      <router-link style="width: 100%;display:block;" :to="{path: data.type_url, query: {type_id: data.type_id,a_v_type:1}}">{{data.type_e_name}}</router-link>
                                    </el-menu-item>
                                </el-menu-item-group>
                            </el-submenu>
                        </div>
                    </el-menu>
                </div>

                <div class="toolbar" :class="{'toolbar-closed':isCollapse==true,'toolbar-put':isCollapse==false}">
                    <div style="height: 60px;">
                        <div style="float: left;margin-top: 5px;">
                            <span style="font-size: 24px"> Product information </span>
                        </div>
                        <div style="float: right;margin-top: 10px;">
                            <!--<img src="../../assets/images/product/excel.png">-->
                            <!--<span style="color: rgba(90,204,155,1);cursor: pointer">下载Excel表格</span>-->
                            <el-button type="primary" @click="pdf_xz()">Selection Manua</el-button>
                            <el-button type="primary" @click="reset"> Reset Filter </el-button>
                            <el-button type="primary" @click="customTable()"> Custom Table </el-button>
                            <!--<el-button type="primary">显示/隐藏列</el-button>-->
                        </div>
                    </div>

                    <div id="wtq_height">
                        <el-table v-loading="loading"
                                  :data="tableData"
                                  style="width: 100%;min-height:500px"
                                  stripe
                                  highlight-current-row
                                  border
                                  height="670px"
                                  >
                            <el-table-column height="300" prop="pro_name" :width="200" fixed="left">
                                <template slot-scope="scope">
                                    <div style="text-align: center;font-size: 14px;font-weight: 600;padding: 10px 0;">
                                      <router-link target="_blank" :to="{path: 'detaile', query: {pro_id: scope.row.pro_id}}" style="color: #000000">{{scope.row.pro_name}}</router-link>
                                    </div>
                                </template>
                                <template slot="header" slot-scope="scope">
                                <tr style="background-color:#eff5ff;width: 100%;display: inline-block;height: 50px !important;">
                                    <div class="table-header">
                                        <div class="chip-chinese-header" style="width:200px"><pre>Part Number</pre></div>
                                    </div>
                                </tr>
                                <tr style="width: 100%;display: inline-block;height: 150px !important;">
                                    <div class="chip-header-select" style="background-color: white;width:200px;">
                                        <div class="chip-header-select-box_2" style="background-color: white;">
<!--                                            <ul>-->
<!--                                                <li class="table-li" v-for="(item,index) in chipList"-->
<!--                                                    :key="index"-->
<!--                                                    :class="{'selected':chipFlag.indexOf(index+'-'+item) !== -1}"-->
<!--                                                    >-->
<!--&lt;!&ndash;                                                  <pre>{{item}}</pre>&ndash;&gt;-->
<!--                                                </li>-->
<!--                                            </ul>-->
                                        </div>
                                    </div>
                                </tr>
                                    
                                    
                                </template>
                            </el-table-column>
                            <el-table-column height="300" :prop="item.attr_id"
                                             v-for="(item,index) in productData"
                                             :key="index"
                                             :width="item.attr_e_name === 'Others' ? 200 : item.attr_e_name === 'Other' ? 200 : 140">
                                  <template slot="header" slot-scope="scope">
                                      <tr style="background-color:#eff5ff;width: 100%;display: inline-block;height: 50px !important;">
                                          <div class="table-header">
                                              <div class="chip-chinese-header" style="width:100%;" :style="item.attr_e_name === 'Others' ? 'width:200px' : item.attr_e_name === 'Other' ? 'width:200px;' : ''"><pre>{{item.attr_e_name}}</pre></div>
                                          </div>
                                      </tr>
                                      <tr style="display: inline-block;" v-bind:style="item.sour_ok*1=== 1 ? 'border: 1px solid #acacac;width: calc(100% - 2px);height: 148px !important;' : 'width: 100%;height: 150px !important;'">
                                          <div class="chip-header-select" style="width: 100%;background-color: white;"  :style="item.attr_e_name === 'Others' ? 'width:200px;' : item.attr_e_name === 'Other' ? 'width:200px;' : ''">
                                              <div :class="item.sour_ok === 2 ? chip-header-select-box_2 : chip-header-select-box" style="height: 150px;overflow: auto;">
                                                  <ul v-if="item.sour_ok*1 === 1">
                                                      <li class="table-li" v-for="(data,index) in customDataList[index]"
                                                          :key="index"
                                                          :class="{'selected':chipFlag.indexOf(index+'-'+data) !== -1}"
                                                          @click="getChipValue(data,index,item.attr_id)"><pre style="font-weight: initial;">{{data}}</pre>
                                                      </li>
                                                  </ul>
                                              </div>
                                          </div>
                                      </tr>
                                  </template>
                                  <template slot-scope="scope">
                                    <div style="text-align: center;font-size: 14px;padding: 10px 0;">
                                        <pre>{{scope.row[item.attr_id]}}</pre>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <el-dialog
                    title=" Custom table "
                    :visible.sync="dialogVisible"
                    v-dialogDrag
                    width="700px">
                <el-button class="custom-but" @click="allPitchOn">ALL</el-button>
                <el-button class="custom-but" type="primary" @click="allPitchOff">Reset</el-button>
                <el-checkbox-group v-model="checkList">
                    <el-checkbox :label="(item.attr_e_name!='' && item.attr_e_name)?item.attr_e_name:item.attr_name" v-for="item in customProductData" :key="item"></el-checkbox>
                </el-checkbox-group>
                <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">N O</el-button>
                <el-button type="primary" @click="saveCustom">O K</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import api from '@/http/request'

export default {
    name: "product",
    data () {
        return {
            isCollapse: false, // 菜单显示
            menuContent: [], // 菜单产品目录
            a_v_type: 1, // 默认为1
            identifying: '1-1', //
            menuIndex: 0, // 展开菜单下标
            pro_name: 'pro_name', // 芯片绑定值
            bindingObj: [], //搜索条件
            dataList: [], // 搜索合集
            customDataList: [], // 自定义搜索合集
            productData:[], // 产品表格
            customProductData:[], // 自定义产品表头
            // chipList:['SH69P25-SH69P21-SH69P20C-SH79F081B-SH79', 'SH79F081B-SH79', 'AA-SH69P25-SH69P21', 'SH79F081B-CCC', 'SH79F081B-BBB', 'SH69P20C-SH79F081B-AAA'], // 芯片型号
            chipList:[], // 芯片型号
            checkList:[],
            dialogVisible: false, // 自定义
            flag: -1,
            iconClass: 'el-icon-s-fold',
            fullScreenFlag: 1,
            loading: false,
            tableData: [],
            chipFlag: [],
            memoryFlag: -1,
            storageFlag: -1,
            cpuhzFlag: -1,
            voltageFlag: -1,
            ioFlag: -1,
            breakSourceFlag: -1,
            breakSourceFlag1: -1,
            timerFlag: -1,
            breakSourceList: ['3x16bits', '4x16bits'],
            breakSourceList1: ['3x16bits', '4x16bits'],
            req: {
                chip: '',
                memory: '',
                storage: '',
                cpuhz: '',
                voltage: '',
                io: '',
                breakSource: '',
                timer: '',
                breakSource1: '',
            },
        }
    },
    watch: {
        '$router' (to, from) {
            if (to.path === '/api/getListTest') {
                this.message = this.$router.query.msg;
            }
        },

    },
    mounted: function () {
        this.getProductList();
        this.getMenuContent();
        console.log('this.$http', this.$http)

        // // handleScroll为页面滚动的监听回调
        // window.addEventListener('scroll', this.handleScroll);
        //
        // // 监听dom渲染完成
        // this.$nextTick(function(){
        //   // 这里fixedHeaderRoot是吸顶元素的ID
        //   let header = document.getElementById("productTable");
        //   // 这里要得到top的距离和元素自身的高度
        //   this.offsetTop = header.offsetTop;
        //   this.offsetHeight = header.offsetHeight;
        //   console.log("offsetTop:" + this.offsetTop + "," + this.offsetHeight);
        // });
    },

    methods: {
        // 选择全部
        allPitchOn() {
            let _this = this
            _this.checkList =[]
            for (let i = 0; i <_this.customProductData.length ; i++) {
                _this.checkList.push(_this.customProductData[i].attr_name)
            }
        },
        // 全部不选
        allPitchOff() {
            this.checkList = []
        },
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        getProductList: function () {
            let _this = this;
            // 获取参数type_id的值
            let url = location.href  // 查询当前url
            let type_id = url.slice(url.indexOf("type_id=")+8)
            type_id = type_id.slice(0, type_id.indexOf("&"))
            
            let type_id2 = this.get_get_val('type_id2');
            
            let layerShade;
            _this.loading = true
            this.$axios({
                method:'get',
                url:'/api/pre/json_go/type_pro?type_id='+type_id + '&a_v_type=' + this.a_v_type + '&type_id2=' + type_id2,
                }).then((response) =>{ // 这里使用了ES6的语法
                _this.tableData = Object.keys(response.data.data).map(function (e) { return response.data.data[e]})
                // 替换<br>
                let reg = new RegExp("<br>", "g"); // g,表示全部替换
                let keys = []
                if (_this.tableData.length > 0){
                    keys = Object.keys(_this.tableData[0])
                }
                if(keys.length > 0){
                    _this.tableData.map((item) => {
                        for (let i = 0; i < keys.length ; i++) {
                            item[keys[i]] = (item[keys[i]]+'').replace(reg, "\r\n")
                            if(keys[i] === 'pro_name'){
                                this.chipList.push(item[keys[i]])
                            }
                        }
                    })
                }
                _this.productData = Object.keys(response.data.title).map(function (e) { return response.data.title[e]})
                // 替换<br>
                keys = []
                if (_this.productData.length > 0){
                    keys = Object.keys(_this.productData[0])
                }
                if(keys.length > 0){
                    _this.productData.map((item) => {
                        for (let i = 0; i < keys.length ; i++) {
                            item[keys[i]] = (item[keys[i]]+'').replace(reg, "\r\n")
                        }
                    })
                }
                this.dataList = Object.keys(response.data.sour).map(function (e) { return response.data.sour[e]})
                // 替换<br>
                keys = []
                if (_this.dataList.length > 0){
                    keys = Object.keys(_this.dataList[0])
                }
                if(keys.length > 0){
                    _this.dataList.map((item) => {
                        for (let i = 0; i < item.length ; i++) {
                            item[keys[i]] = (item[keys[i]]+'').replace(reg, "\r\n")
                        }
                    })
                }
                _this.customDataList = _this.dataList
                _this.customProductData = []
                for (let i = 0; i <_this.productData.length ; i++) {
                    _this.productData[i].attr_id = _this.productData[i].attr_id + ''
                    _this.checkList.push(_this.productData[i].attr_name)
                    _this.customProductData.push(_this.productData[i])
                }
                console.log('_this.customProductData+++',_this.customProductData)
                _this.loading = false
                
                this.newheight();
            }).catch((error) =>
                console.log(error)       //请求失败返回的数据
            )
        },
        // 获取左侧菜单
        getMenuContent () {
            this.$axios({
                method:'get',
                url:'/api/pre/json_go/look_one?type=3',
            }).then((response) =>{ // 这里使用了ES6的语法
                let _this = this
                let leftMenuData = response.data.men
                for (let i = 0; i < leftMenuData.length; i++) {
                    if(leftMenuData[i].type_name === '产品'){
                        this.menuContent = leftMenuData[i].child
                    }
                }
                // 获取参数type_id的值
                let url = location.href  // 查询当前url
                let type_id = url.slice(url.indexOf("type_id=")+8, -1)
                type_id = type_id.slice(0, type_id.indexOf("&"))
                
                let type_id2 = this.get_get_val('type_id2');
                if(type_id2){
                    type_id=type_id2;
                }
                
                // 过滤掉type_staue=2的节点
                for (let n = this.menuContent.length-1; n >= 0; n--) {
                    if(!_this.menuContent[n].hasOwnProperty("child")){
                        if("2" ===_this.menuContent[n].type_staue) {
                            _this.menuContent.splice(n, 1);
                        }
                    }else {
                      for (let j = 0; j <_this.menuContent[n].child.length ; j++) {
                          if("2" ===_this.menuContent[n].child[j].type_staue){
                              _this.menuContent[n].child.splice(j, 1);
                          }
                      }
                    }
                }
                // 展开的目录下标
                for (let n = this.menuContent.length-1; n >= 0; n--) {
                    if(!_this.menuContent[n].hasOwnProperty("child")){
                        // 过滤掉type_staue=2的节点
                        if(type_id === _this.menuContent[n].type_id + ''){
                            _this.menuIndex = n
                            _this.identifying = n

                        }
                    }else {
                        for (let j = 0; j <_this.menuContent[n].child.length ; j++) {
                            if(type_id === _this.menuContent[n].child[j].type_id + ''){
                                _this.menuIndex = n
                                _this.identifying = n + "-" + j
                            }
                        }
                    }
                }
            }).catch((error) =>
                console.log(error)       //请求失败返回的数据
            )
        },
        changeBackground (number, type) {
            this.flag = number
        },
        getChipValue: function (item, index,attrId) {
            if(this.chipFlag.indexOf(index+'-'+item) === -1){
              this.chipFlag.push(index+'-'+item);
              this.bindingObj.push(attrId+'-+-'+item)
            } else {
              this.chipFlag.splice(this.chipFlag.indexOf(index+'-'+item),1);
              this.bindingObj.splice(this.bindingObj.indexOf(attrId+'-+-'+item),1);
            }
            this.req.chip = item;
            this.getProductListByCondition(this.bindingObj);
        },
        getMemoryValue: function (item, index) {
            this.memoryFlag = index;
            this.req.memory = item;
            this.getProductListByCondition();
        },
        getStorageValue: function (item, index) {
            this.storageFlag = index;
            this.req.storage = item;
            this.getProductListByCondition();
        },
        getCpuhzValue: function (item, index) {
            this.cpuhzFlag = index;
            this.req.cpuhz = item;
            this.getProductListByCondition();
        },
        getVoltageValue: function (item, index) {
            this.voltageFlag = index;
            this.req.voltage = item;
            this.getProductListByCondition();
        },
        getIoValue: function (item, index) {
            this.ioFlag = index;
            this.req.io = item;
            this.getProductListByCondition();
        },
        getBreakSourceValue: function (item, index) {
            this.breakSourceFlag = index;
            this.req.breakSource = item;
            this.getProductListByCondition();
        },
        getBreakSourceValue1: function (item, index) {
            this.breakSourceFlag1 = index;
            this.req.breakSource1 = item;
            this.getProductListByCondition();
        },
        getTimerValue: function (item, index) {
            this.timerFlag = index;
            this.req.timerFlag = item;
            this.getProductListByCondition();
        },
        getProductListByCondition: function (sourData) {
            // 获取参数type_id的值
            let url = location.href  // 查询当前url
            let type_id = url.slice(url.indexOf("type_id=")+8, -1)
            type_id = type_id.slice(0, type_id.indexOf("&"))
            var formdata = new FormData();
            for (let i = 0; i <sourData.length; i++) {
                let sour = sourData[i].split("-+-")
                formdata.append("sour["+sour[0]+"][]",sour[1])
            }
            this.$axios({
            method:'post',
            url:'/api/pre/json_go/type_pro?type_id='+type_id  + '&a_v_type=' + this.a_v_type+'&english=2',
            data:formdata
            }).then((response) =>{ // 这里使用了ES6的语法
                let _this = this
                _this.tableData = Object.keys(response.data.data).map(function (e) { return response.data.data[e]})
                // 替换<br>
                let reg = new RegExp("<br>", "g"); // g,表示全部替换
                let keys = []
                if (_this.tableData.length > 0){
                    keys = Object.keys(_this.tableData[0])
                }
                if(keys.length > 0){
                    _this.tableData.map((item) => {
                        for (let i = 0; i < keys.length ; i++) {
                            item[keys[i]] = (item[keys[i]]+'').replace(reg, "\r\n")
                        }
                    })
                }
            }).catch((error) =>
                console.log(error)       //请求失败返回的数据
            )
        },
        // 改变左侧菜单标识
        noIdentifying: function (item, index) {
            // 获取参数type_id的值
            let url = location.href  // 查询当前url
            let type_id = url.slice(url.indexOf("type_id=")+8, -1)
            type_id = type_id.slice(0, type_id.indexOf("&"))
            location.href = '/product?type_id='+type_id  + '&a_v_type=' + this.a_v_type;
            return false;
            this.productData=[];
            this.identifying = item;
            this.menuIndex = index;
            this.getProductList()
            //this.reset()
        },
        reset: function () {
            this.chipFlag = [];
            this.memoryFlag = -1;
            this.storageFlag = -1;
            this.cpuhzFlag = -1;
            this.voltageFlag = -1;
            this.ioFlag = -1;
            this.timerFlag = -1;
            this.breakSourceFlag = -1;
            this.breakSourceFlag1 = -1;
            // 获取参数type_id的值
            let url = location.href  // 查询当前url
            let type_id = url.slice(url.indexOf("type_id=")+8, -1)
            type_id = type_id.slice(0, type_id.indexOf("&"))
            this.$axios({
                method:'get',
                url:'/api/pre/json_go/type_pro?type_id='+type_id + '&a_v_type=' + this.a_v_type+'&english=2',
            }).then((response) =>{ // 这里使用了ES6的语法
                let _this = this
                _this.tableData = Object.keys(response.data.data).map(function (e) { return response.data.data[e]})
                let reg = new RegExp("<br>", "g"); // g,表示全部替换
                let keys = []
                if (_this.tableData.length > 0){
                    keys = Object.keys(_this.tableData[0])
                }
                if(keys.length > 0){
                    _this.tableData.map((item) => {
                        for (let i = 0; i < keys.length ; i++) {
                            item[keys[i]] = (item[keys[i]]+'').replace(reg, "\r\n")
                        }
                    })
                }
            }).catch((error) =>
                console.log(error)       //请求失败返回的数据
            )
        },
        fullScreen: function () {
            if (this.fullScreenFlag === 0) {
                this.iconClass = "el-icon-s-unfold";
                this.fullScreenFlag = 1;
                this.isCollapse = false;
            } else {
                this.iconClass = "el-icon-s-fold";
                this.fullScreenFlag = 0;
                this.isCollapse = true;
            }
        },
        customTable () {
            let vm = this;
            vm.dialogVisible = true;
        },
        saveCustom () {
            let vm = this;
            let pData = [];
            let data = [];
            this.customDataList = this.dataList
            for (let j = 0; j < vm.checkList.length; j++) {
                let check = vm.checkList[j]
                for (let i = 0; i < vm.customProductData.length; i++) {
                    let product = vm.customProductData[i].attr_name
                    if (check === product) {
                        pData.push(vm.customProductData[i])
                        data.push(vm.customDataList[i])
                    }
                }
            }
            //vm.productData = pData;
            for (let i = 0; i <pData.length ; i++) {
                pData[i].attr_id = pData[i].attr_id + ''
            }
            vm.productData = Object.assign({}, pData);
            this.customDataList = data;
            if(vm.checkList.length <= 0){
                alert('至少勾选一个')
            }else {
              this.reset()
              vm.dialogVisible = false;
            }

        },
         handleScroll(){
             // 得到页面滚动的距离
             let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
             // 判断页面滚动的距离是否大于吸顶元素的位置
             this.headerFixed = scrollTop > (this.offsetTop - this.offsetHeight * 2);
             this.leftShow = false;
         },
         pdf_xz(){
            window.open('web/file/Selection_Manual(2019).zip');
         },
         newheight(){
            let hei=document.documentElement.clientHeight-187;
            hei=hei*1+document.documentElement.scrollTop*1;
            document.getElementById("wtq_height").firstChild.style.height=hei+'px';
            
         },
         get_get_val:function (get_name){
                // 获取参数type_id的值
                var reg = new RegExp("(^|&)" + get_name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r != null){
                    return decodeURI(r[2]);
                }else{
                    return '';
                }
            },
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
}
window.onresize = () =>{
    let hei=document.documentElement.clientHeight-187;
    //alert(document.documentElement.scrollTop)
    hei=hei*1+document.documentElement.scrollTop*1;
    document.getElementById("wtq_height").firstChild.style.height=hei+'px';

}
</script>

<style>
    .product .el-table__body-wrapper::-webkit-scrollbar{width:10px;}
    .product .el-table__footer-wrapper { background-color: rgba(108,152,255,1); }
    .el-table thead.is-group th {  /*! autoprefixer: off */ background-color: rgba(108,152,255,1);  /* autoprefixer: on */ }
    .product li { color: #fff }
    .product .el-table th>.cell { color: #333 !important;padding: 0 !important;  }
    .product .table-content { overflow:auto;height: 150px;width: 120px;background: #fff;margin-left: 5px; }
    .product .table-li {color: rgba(102, 102, 102, 1);line-height: 22px !important;font-size: 12px;padding:0 8px;color: #000000;}
    /*.product .table-li:hover { background: #b2c8cb}*/
    .product .el-table thead.is-group th { background: rgba(239,245,255,1) !important;}
    .product .selected { background-color: #99ccff !important;}
    .product tr { height: 30px !important; }
    .product .table-header { font-size: 16px;text-align: center !important;padding-left: 0px !important; }
    .product .el-table th div { display: block !important;text-align: center; }

    .product .chip-chinese-header {width: 140px;height: 45px !important;line-height: 20px;border-right: 1px solid #EBEEF5;font-size: 14px;font-family: "Microsoft Yahei";padding-top: 5px}
    .product .chip-english-header {width: 140px;height: 32px !important;line-height: 14px;font-size: 12px;color: #000000;border-bottom: 1px solid #EBEEF5;border-right: 1px solid #EBEEF5;font-size: 12px;font-family: "Microsoft Yahei";}

    .product .chinese-header {width: 240px;height: 24px  !important;;line-height: 24px;border-right: 1px solid #EBEEF5;font-size: 14px;}
    .product .english-header {width: 240px;height: 24px  !important;line-height: 14px;font-size: 12px;color: #000000;border-bottom: 1px solid #EBEEF5;border-right: 1px solid #EBEEF5;font-size: 12px;}

    .product .chip-header-select { width: 140px;height: 180px;padding: 0px !important;border-right: 1px solid #EBEEF5;font-family: "Microsoft Yahei";}
    .product .chip-header-select-box {width: 135px;height: 170px;margin-left: 5px;margin-top: 5px;overflow:scroll;background-color: #fff;border-radius: 5px;font-family: "Microsoft Yahei";}
    .product .chip-header-select-box_2 {width: 135px;height: 170px;margin-left: 5px;margin-top: 5px;background-color: rgba(239,245,255,1);border-radius: 5px;font-family: "Microsoft Yahei";}
    .product .chip-header-select-box ul {text-align: left;font-family: "Microsoft Yahei";}

    .product .header-select { width: 240px;height: 180px;padding: 0px !important;border-right: 1px solid #EBEEF5;}
    .product .header-select-box {height: 170px;margin-left: 5px !important;margin-top: 5px;overflow:scroll;background-color: #fff;border-radius: 5px;}

    .product .recommend-article { font-size: 24px;height: 50px;padding-top: 10px; }
    .product .product-p { font-size: 12px;color: rgba(102,102,102,1); margin: 5px 0}
    .product .article-span { font-size: 16px }

    .product .el-table .cell {font-size: 13px;font-family: "Microsoft Yahei";}

    .product .el-table td, .el-table th {padding: 0px !important;text-align: center;border-right: 1px solid #EBEEF5;color: #000000;}
    .product .el-table th>.cell {background-color: rgba(239,245,255,1);}
    .el-table__body tr.current-row>td {background-color: #DDE9FF;}

    .product .article-item {margin-top: 15px;font-size: 14px;padding-left: 5px;cursor: pointer;}

    .product .article-item-start {font-size: 14px;padding-left: 5px;cursor: pointer;}

    .product .article-item-end {margin-top: 25px;font-size: 14px;padding-left: 5px;cursor: pointer;}

    .selecteds {background-color: #bed6ff;}

    html, body{margin: 0;height: 100%;}
    .main{background:#ccc;width: 100%;height: 100%;margin: auto;min-width: 1000px;}

    .content{width: 100%;height: 100%;display: inline-block;}
    .toolbar{height: 100%;display: inline-block;float: right;}
    .toolbar-closed{width: 97%;}
    .toolbar-put{width: 82%;}
    .main_container{display: table-cell;width: 140px;height: 100%;}

    tbody > tr {height: 40px;}

    .isFixed{ position: fixed;top: 107px;left: 0;right: 0;}
    /* 菜单 */
    /*.product-menu .menus-title { font-size: 24px;height: 50px;padding-left: 20px;display: inline-block;}*/
    .product-menu {padding-top: 35px;display: inline-block;position: relative;float: left;}
    .product-menu-closed {width: 3%;}
    .product-menu-put {width: 18%;}
    .product-menu .flod { font-size: 24px;position: absolute;top: 0;right: 10px;}
    /*.product-menu .el-menu-item.is-active {background: #eff5ff;}*/
    .product-menu .el-menu-item.identifying {background: #eff5ff;}
    .product-menu .el-menu {width: 100%;}
    .product-menu .el-menu .menu-left {display: inline-block; outline:none;width: 100%;}
    .product-menu .el-menu .menu-left .el-menu-item {padding: 0 20px;}
    .product-menu .el-menu .menu-left .el-menu-item-group {padding: 0;}
    .product-menu .el-menu .menu-left .el-menu-item-group .el-menu-item-group__title {padding: 0;}

    .product-menu .el-menu li {padding-top: 8px;}
    .product-menu .el-menu li .menu-headline {overflow: hidden;font-size: 30px;color: #000;line-height: 35px}
    .product-menu .el-menu li .menu-box {overflow: hidden;}
    .product-menu .el-menu .menu-title {font-size :16px;color: #000000;line-height: 30px;}
    .product-menu .el-menu .menu-text {font-size :12px;color: #666666;line-height: 20px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
    .product-menu .el-menu--collapse {width: 40px;}
    .product-menu .el-menu .el-submenu .el-menu-item {height: 35px;line-height: 35px}

    pre {margin: 0px;font-family: "Microsoft Yahei";}
    a {color: #333333;}
    /* 弹窗 */
    .el-checkbox {width: 220px;margin-left: 80px;line-height: 40px;}
    .custom-but {width: 60px;height: 40px;margin: 0 0 20px 40px;padding: 0;}
</style>



// WEBPACK FOOTER //
// src/pages/product/product.vue